<template>
  <div
    class="w-100 relative h-100"
    style="flex-grow: 1;"
  >
    <BgLeaves
      v-if="brand === 'lh'"
      :trigger="leaves"
      :position="[1, 0, 1, 0]"
      :inset="10"
    />
    <transition-group
      @enter="animEnterSlider"
      @leave="animLeaveSlider"
      :css="false"
      mode="out-in"
      class="relative h-100 pr5 w-100"
      style="margin-left: 25vw;"
      tag="div"
    >
      <div
        v-for="(purchaseOption, i) in content"
        :key="purchaseOption.title"
        v-show="i === activeTab"
        class="absolute top-50 left-0"
        style="transform: translateY(-50%)"
      >
        <div
          ref="title"
          class="f1 b mb4"
          :class="{
            'purple': brand === 'lh',
            'dark-gray': brand === 'lq'
          }"
          v-html="purchaseOption.title"
        />
        <div
          ref="divider"
          class="bt bw1 w3"
          :class="{
            'b--purple': brand === 'lh',
            'b--dark-gray': brand === 'lq',
          }"
        />
        <div
          class="lh-copy measure-wide"
          style="max-width: 60em"
          v-html="purchaseOption.text"
        />
      </div>
    </transition-group>
  </div>
</template>

<script>
import transitions from '../../transitions.js'
import BgLeaves from '@/components/BgLeaves.vue'

export default {
  name: 'PurchaseOptions',
  components: {
    BgLeaves
  },
  props: {
    brand: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      leaves: false
    }
  },
  computed: {
    activeTab () {
      return this.$store.state.activeTab
    },
    prevTab () {
      return this.$store.state.prevTab
    },
    content () {
      if (this.$store.state.content) {
        return this.$store.state.content.purchaseOptions
      } else {
        return null
      }
    }
  },
  methods: {
    animEnterSlider (el, done) {
      if (this.activeTab > this.prevTab) {
        transitions.fadeInRight(el, done)
      } else {
        transitions.fadeInLeft(el, done)
      }
    },
    animLeaveSlider (el, done) {
      if (this.activeTab > this.prevTab) {
        transitions.fadeOutLeft(el, done)
      } else {
        transitions.fadeOutRight(el, done)
      }
    },
    titleAnim () {
      const divider = this.$refs.divider
      const title = this.$refs.title
      transitions.titleTransition(title, divider)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.leaves = true
      vm.titleAnim()
    })
  },
  beforeRouteLeave (to, from, next) {
    this.leaves = false
    setTimeout(() => {
      next()
    }, 200)
  }
}
</script>
